module.exports = __webpack_public_path__ + "res/free_kick.4ed5706760e370e67785d06d9ff75c34.webp";